import * as _gensync3 from "gensync";

var _gensync2 = "default" in _gensync3 ? _gensync3.default : _gensync3;

import { dew as _config2Dew } from "./config";
import { dew as _parser2Dew } from "./parser";
import { dew as _normalizeOpts2Dew } from "./transformation/normalize-opts";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.parseSync = exports.parseAsync = exports.parse = void 0;

  function _gensync() {
    const data = _gensync2;

    _gensync = function () {
      return data;
    };

    return data;
  }

  var _config = _config2Dew();

  var _parser = _parser2Dew();

  var _normalizeOpts = _normalizeOpts2Dew();

  const parseRunner = _gensync()(function* parse(code, opts) {
    const config = yield* (0, _config.default)(opts);

    if (config === null) {
      return null;
    }

    return yield* (0, _parser.default)(config.passes, (0, _normalizeOpts.default)(config), code);
  });

  const parse = function parse(code, opts, callback) {
    if (typeof opts === "function") {
      callback = opts;
      opts = undefined;
    }

    if (callback === undefined) return parseRunner.sync(code, opts);
    parseRunner.errback(code, opts, callback);
  };

  exports.parse = parse;
  const parseSync = parseRunner.sync;
  exports.parseSync = parseSync;
  const parseAsync = parseRunner.async;
  exports.parseAsync = parseAsync;
  return exports;
}